import {
  default as CreateItem,
  default as ItemForm,
} from '@/components/forms/master/inventory/item/ItemForm';
import Cookies from 'js-cookie';
import { AuthProvider } from '@/context/AuthContext';
import { StockContextProvider } from '@/context/StockContext';
import ToastProvider from '@/context/ToastContext';
import { TransactionContextProvider } from '@/context/TransactionContext';
import { TransactionReturnContextProvider } from '@/context/transactionContext/TransactionReturn';
import { AdminDashboardLayout } from '@/layouts';
import DashboardLayout from '@/layouts/DashboardLayout';
import Customers from '@/pages/admin/customers';
import CreateCustomer from '@/pages/admin/customers/form/CreateCustomer';
import EditCustomer from '@/pages/admin/customers/form/EditCustomer';
import SuperAdminUserCreate from '@/pages/admin/customers/form/SuperAdminUserCreate';
import SuperAdminUserEdit from '@/pages/admin/customers/form/SuperAdminUserEdit';
import AdminDashboard from '@/pages/admin/dashboard';
import Branch from '@/pages/admin/master/branch';
import AdminCompany from '@/pages/admin/master/company';
import CreateCompany from '@/pages/admin/master/company/form/CreateCompany';
import EditCompany from '@/pages/admin/master/company/form/EditCompany';
import Roles from '@/pages/admin/roles';
import CreateRole from '@/pages/admin/roles/form/CreateRole';
import EditRoleMapping from '@/pages/admin/roles/form/EditRoleMapping';
import RoleMapping from '@/pages/admin/roles/form/RoleMapping';
import UserCompanyMappingCreate from '@/pages/admin/roles/form/UserCompanyMappingCreate';
import CreatePrinter from '@/pages/admin/roles/mapping/CreatePrinter';
import RoleMenuMappingList from '@/pages/admin/roles/mapping/MenuRoleMappingList';
import PrinterList from '@/pages/admin/roles/mapping/PrinterList';
import UserCompanyMappingList from '@/pages/admin/roles/mapping/UserCompanyMappingList';
import RoleUserMappingList from '@/pages/admin/roles/mapping/UserRoleMappingList';
import Subscription from '@/pages/admin/subscription';
import CreateSubscriptionForm from '@/pages/admin/subscription/Form/CreateSubscriptionForm';
import EditSubscriptionForm from '@/pages/admin/subscription/Form/EditSubscriptionForm';
import UserAdmin from '@/pages/admin/users';
import SuperAdminUserActive from '@/pages/admin/users/SuperAdminUserActive';
import SuperAdminUserList from '@/pages/admin/users/SuperAdminUserList';
import Group from '@/pages/master/accounts/groups/Group';
import Ledger from '@/pages/master/accounts/ledger/Ledger';
import InventoryGroup from '@/pages/master/inventory/group/Group';
import InventorySubGroup from '@/pages/master/inventory/subGroup/SubGroup';
import Item from '@/pages/master/inventory/item/Item';

import Login from '@/pages/starter/auth/base';
import BranchList from '@/pages/starter/BranchList';
import CompanyList from '@/pages/starter/CompnayList';

import { VersionList } from '@/pages/superadmin/versions';
import CreateVerison from '@/pages/superadmin/versions/CreateVersion';
import SuperadminVersionMenuMappingList from '@/pages/superadmin/versionMenuMapping/MenuVersionMappingList';
import SuperadminVersionMenuMapping from '@/pages/superadmin/versionMenuMapping/VersionMenuMapping';
import EditSuperadminVersionMenuMapping from '@/pages/superadmin/versionMenuMapping/EditVersionMenuMapping';
import { CompanyLimitList } from '@/pages/superadmin/companyLimits';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRouteSetup from './ProtectedRouteSetup';
import ProtectedRouteSetupAdmin from './ProtectedRouteSetupAdmin';
import DealClose from '@/pages/loan/dealClose/DealClose';

import Check from '@/components/pages/Check';
import LayoutSettings from '@/pages/admin/barcode/pages/LayoutSettings';
import PRNsettings from '@/pages/admin/barcode/pages/PRNsetting';
import AddPRN from '@/pages/admin/barcode/pages/AddPRN';
import { getTokens, getUserRedirect } from './authHelpers';

import SuperAdminDashboard from '@/pages/superadmin/dashboard';
import { NavigationTracker } from '@/common/navigation-history';
import { DeviceIdList } from '@/pages/admin/device-idenification';

import PermissionMenuMapping from '@/pages/admin/roles/mapping/PermissionMenuMapping';
import EditPermissionMenuMapping from '@/pages/admin/roles/mapping/EditPermissionMenuMapping';

import BranchVersionAssignmentList from '@/pages/superadmin/branchVersionAssignment/BranchVersionAssignmentList';

import BillFormatAdmin from '@/pages/admin/master/billFormat';

import { Suspense } from 'react';
import { Spin } from 'antd';
import {
  DisableDynamicCodeWindowLazy,
  PosSalesLazy,
  PosOrderLazy,
  PurchaseLazy,
  PurchaseListLazy,
  PurchaseReturnCodeWindowLazy,
  PurchaseReturnLazy,
  PurchaseReturnListLazy,
  ReceiveKarigarLazy,
  ReceiveKarigarListLazy,
  ReceivePartyLazy,
  ReceivePartyListLazy,
  ReceiveRefineLazy,
  ReceiveRefineListLazy,
  SalesLazy,
  SalesListLazy,
  SalesOrderLazy,
  SalesOrderListLazy,
  SalesReturnLazy,
  SalesReturnListLazy,
  UtilCodeWindowFormLazy,
} from './lazyImport/transaction';
import {
  CashToMetalLazy,
  CashToMetalListLazy,
  ContraVoucherCreateLazy,
  ContraVoucherEditLazy,
  ContraVoucherListLazy,
  DisableFirstTableLazy,
  IssueKarigarCreateLazy,
  IssueKarigarListLazy,
  IssuePartyCreateLazy,
  IssuePartyListLazy,
  IssueRefineCreateLazy,
  IssueRefineListLazy,
  JornalVoucherCreateLazy,
  JornalVoucherEditLazy,
  JornalVoucherListLazy,
  MetalToCashLazy,
  MetalToCashListLazy,
  MetalTransferCreateLazy,
  MetalTransferEditLazy,
  MetalTransferListLazy,
  PaymentVoucherCreateLazy,
  PaymentVoucherEditLazy,
  PaymentVoucherListLazy,
  ReceiptVoucherCreateLazy,
  ReceiptVoucherEditLazy,
  ReceiptVoucherListLazy,
  StockLazy,
  StockListLazy,
} from './lazyImport/accounting';
import {
  BillSetupListLazy,
  ChangePasswordLazy,
  ChangeSalesRateLazy,
  ChangeTrayNameLazy,
  ChangeUserPasswordLazy,
  CodeWindowFormModalLazy,
  CodeWindowFormModalSalesReceiveLazy,
  CodeWindowLazy,
  CodeWindowStockAdjustmentLazy,
  DashboardLazy,
  ErrorLazy,
  FinancialYearLazy,
  JAddTemplateLazy,
  BillSetupDesignerLazy,
  ClassicTemplateEditLazy,
  JweleryNewStickerLazy,
  OTPVerificationLazy,
  ProductCatalogPageLazy,
  ProductDetailPageLazy,
  PurchaseWithModalLazy,
  PurchaseWithModalSalesLazy,
  ReceiveCodeWindowLazy,
  ReceiveModalLazy,
  SalesOrderCodeWindowLazy,
  StockAdjustmentLazy,
  StockAdjustmentListLazy,
  StockCodeLazy,
  StockItemCodeWindowLazy,
  StoreSetupListLazy,
  SubDashboardLazy,
  TodayGoldRateLazy,
  UnAuthorizedLazy,
  UserActivityLazy,
} from './lazyImport/others';
import {
  AdvanceLazy,
  CashBankReportLazy,
  CustomerLedgerReportLazy,
  DayBookreportLazy,
  DayStockLedgerReportLazy,
  StockBookReportLazy,
  ExpenseReportLazy,
  ExpenseDetailReportLazy,
  GoldRateHistoryLazy,
  IrdAnnex5ReportLazy,
  IssueDetailsReportLazy,
  KarigarIssueDetailsReportLazy,
  KarigarLedgerReportLazy,
  KarigarReceiveDetailsReportLazy,
  KarigarReceiveReportLazy,
  KarigarReportLazy,
  LedgerDetailReportLazy,
  LedgerReportLazy,
  LoanBankWiseStockReportLazy,
  LoanDealTrackingReportLazy,
  LoanStockInBankReportLazy,
  LoanStockReportLazy,
  OpeningStockDetailsReportLazy,
  OrderDetailreportLazy,
  OrderReportLazy,
  OrderStatusLazy,
  OrderTrackingReportLazy,
  PartyIssueDetailReportLazy,
  PartyReceiveDetailReportLazy,
  PartyReceiveReportLazy,
  PendingIrdReport,
  PurchaseDetailReportLazy,
  PurchaseReportLazy,
  RefineIssueDetailReportLazy,
  RefineProfitLossReportLazy,
  RefineReceiveDetailReportLazy,
  RefineReceiveReportLazy,
  ReportsLazy,
  SalesBillSummaryLazy,
  SalesDetailsReportLazy,
  SalesRegisterReportLazy,
  SalesReturnReportLazy,
  SalesReturnDetailsReportLazy,
  PurchaseReturnReportLazy,
  PurchaseReturnDetailsReportLazy,
  SalesReturnRegisterReportLazy,
  SalesGrossProfitReportLazy,
  SalesHistoryReportLazy,
  SalesRateChangeHistoryLazy,
  SalesReportLazy,
  StockDetailReportLazy,
  StockLedgerReportLazy,
  StockReceiptDetailsReportLazy,
  StockReceiptReportLazy,
  StockReportLazy,
  StockValuationReportLazy,
  SundryCreditorsReportLazy,
  SundryDeptorsReportLazy,
  TrayNameChangeHistoryLazy,
  VoucherDetailsReportLazy,
  VoucherReportLazy,
  SalesItemWiseReportLazy,
} from './lazyImport/reports';
import {
  BankIssueFormLazy,
  BankIssueListLazy,
  BankReceivesListLazy,
  DealListLazy,
  InterestReceivedFormLazy,
  InterestReceivedListLazy,
  LoanDealCreateLazy,
  PartyLoanDetailsLazy,
  PartyLoanListLazy,
} from './lazyImport/loan';
import TableEditor from '@/pages/transaction/test-component';
import { ControlSettingsList } from '@/pages/superadmin/control-settings';
import PrintPlayGround from '@/components/print-playground';
import { CustomCKEditor } from '@/common/components/ck-editor';
import QzTraySetupList from '@/pages/admin/qz-tray-setup';
import CreateQzTraySetup from '@/pages/admin/qz-tray-setup/form/CreateQzTraySetup';
import EditQzTraySetup from '@/pages/admin/qz-tray-setup/form/EditQzTraySetup';
import SalesQuotationList from '@/pages/transaction/sales-quotation/sales-quotation-list';
import SalesQuotation from '@/pages/transaction/sales-quotation/sales-quotation';
import SalesQuotationWindow from '@/components/forms/transaction/purchase/SalesQuotationWindow';

const RouteSetup = () => {
  const adminToken = Cookies.get('admin_token');
  const superAdminToken = Cookies.get('superadmin_token');
  const tokens = getTokens();
  const redirectPath = getUserRedirect(tokens);
  const otp = localStorage.getItem('otp');
  const pwd = localStorage.getItem('requirePasswordChange');

  return (
    <AuthProvider>
      <NavigationTracker />
      <Suspense
        fallback={
          <div className="tw-flex tw-h-[100vh] tw-justify-center tw-items-center tw-flex-col tw-bg-gradient-to-br tw-from-gray-100 tw-via-gray-200 tw-to-gray-100">
            <Spin size="large" />
            <div className="tw-mx-2 tw-mt-2 tw-text-sm tw-text-gray-500 tw-text-center">
              <span className="tw-font-medium">Dip Artha</span> · Powered by{' '}
              <span className="tw-font-semibold tw-text-gray-600">
                Autonomous Technology
              </span>
            </div>
          </div>
        }
      >
        <Routes>
          {/* Default and Login Routes */}
          {<Route path="/" element={<Navigate to="/login" />} />}
          {
            <Route
              path="/admin/login"
              element={
                adminToken ? <Navigate to="/admin/dashboard" /> : <Login />
              }
            />
          }
          <Route
            path="/superadmin/login"
            element={
              superAdminToken ? (
                <Navigate to="/superadmin/dashboard/" />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/login/"
            element={redirectPath ? <Navigate to={redirectPath} /> : <Login />}
          />
          {pwd && (
            <Route
              path="/changepassword/"
              element={<ChangeUserPasswordLazy />}
            />
          )}
          {otp && (
            <Route
              path="/otp-verification/"
              element={<OTPVerificationLazy />}
            />
          )}
          {/* User Routes */}
          <Route
            element={
              <ProtectedRouteSetup
                allowedRole={['admin', 'user']}
                redirectTo="/login"
              />
            }
          >
            <Route path="userwise/company/list/" element={<CompanyList />} />
            <Route path="userwise/branch/list" element={<BranchList />} />
            <Route
              path="/"
              element={
                <ToastProvider>
                  <TransactionReturnContextProvider>
                    <TransactionContextProvider>
                      <StockContextProvider>
                        <DashboardLayout />
                      </StockContextProvider>
                    </TransactionContextProvider>
                  </TransactionReturnContextProvider>
                </ToastProvider>
              }
            >
              <Route path="dashboard" element={<DashboardLazy />} />
              <Route path="/sub-dashboard/" element={<SubDashboardLazy />} />
              <Route path="ledger/list" element={<Ledger />} />
              <Route path="/test" element={<TableEditor />} />
              <Route path="account/group/list" element={<Group />} />
              <Route path="inventory/item/list" element={<Item />} />
              <Route path="inventory/item/create" element={<CreateItem />} />
              <Route
                path="/masters/inventory/item/edit/:referenceId/"
                element={<ItemForm />}
              />
              <Route path="inventory/group/list" element={<InventoryGroup />} />
              <Route
                path="inventory/sub-group/list"
                element={<InventorySubGroup />}
              />
              <Route path="/purchase/list/" element={<PurchaseListLazy />} />
              <Route path="/purchase/create/" element={<PurchaseLazy />} />
              <Route path="/purchase/edit/:id/" element={<PurchaseLazy />} />
              <Route
                path="transaction/purchase/edit/:id/"
                element={<CodeWindowLazy />}
              />
              <Route
                path="/codewindow/:id"
                element={
                  <>
                    <CodeWindowLazy />
                  </>
                }
              />
              <Route
                path="/purchase-modal/create/"
                element={<PurchaseWithModalLazy />}
              />

              <Route
                path="/purchase-modal-sales/create/"
                element={<PurchaseWithModalSalesLazy />}
              />
              <Route
                path="transaction/purchase-modal/edit/:id/"
                element={<CodeWindowFormModalLazy />}
              />
              <Route
                path="transaction/purchase-modal-sales/edit/:id/"
                element={<CodeWindowFormModalLazy />}
              />

              <Route
                path="/receive-from-party-modal-sales/create/"
                element={<ReceiveModalLazy />}
              />

              <Route
                path="/codewindow-modal-sales/:id"
                element={<CodeWindowFormModalLazy />}
              />

              <Route
                path="/codewindow-modal-sales-receive-party/:id"
                element={<CodeWindowFormModalSalesReceiveLazy />}
              />

              <Route
                path="/codewindow-modal-sales-receive-party/edit/:id"
                element={<CodeWindowFormModalSalesReceiveLazy />}
              />

              <Route
                path="/codewindow-modal/:id"
                element={<CodeWindowFormModalLazy />}
              />
              <Route
                path="/purchase/return/list/"
                element={<PurchaseReturnListLazy />}
              />

              <Route
                path="/purchase/return/create/"
                element={<PurchaseReturnLazy />}
              />
              <Route
                path="/purchase/return/edit/:id/"
                element={<PurchaseReturnLazy />}
              />
              <Route
                path="/sales/return/edit/:id/"
                element={<SalesReturnLazy />}
              />
              <Route
                path="/transaction/receive/karigar/create/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route
                path="/transaction/receive/karigar/edit/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route
                path="/transaction/receive/refine/create/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route
                path="/transaction/receive/refine/edit/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route
                path="/transaction/receive/party/create/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route
                path="/transaction/receive/party/edit/:id"
                element={<ReceiveCodeWindowLazy />}
              />
              <Route path="/opening/stock/list/" element={<StockListLazy />} />
              <Route
                path="/opening/stock/code/:id"
                element={<StockCodeLazy />}
              />
              <Route
                path="/opening/stock/create/"
                element={<StockItemCodeWindowLazy />}
              />
              <Route path="/opening/stock/edit/:id" element={<StockLazy />} />
              <Route
                path="/transaction/stock/create/:id"
                element={<CodeWindowLazy />}
              />

              <Route
                path="/transaction/stock/edit/:id"
                element={<StockItemCodeWindowLazy />}
              />
              <Route
                path="/transaction/stock-adjustment/list/"
                element={<StockAdjustmentListLazy />}
              />
              <Route
                path="/opening/stock-adjustment/create/"
                element={<StockAdjustmentLazy />}
              />
              <Route
                path="/opening/stock-adjustment/edit/:id"
                element={<StockAdjustmentLazy />}
              />
              <Route
                path="/transaction/stock-adjustment/create/:id"
                element={<CodeWindowStockAdjustmentLazy />}
              />
              <Route
                path="/transaction/stock-adjustment/edit/:id"
                element={<CodeWindowStockAdjustmentLazy />}
              />
              <Route path="/sales/list/" element={<SalesListLazy />} />
              <Route path="/sales/create/" element={<SalesLazy />} />
              <Route path="/sales/pos/create/" element={<PosSalesLazy />} />
              <Route path="/sales/edit/:ids" element={<SalesLazy />} />
              <Route
                path="/transaction/sales/create/codewindow/:id"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/sales/edit/:id"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/playground/"
                element={
                  <div>
                    <CustomCKEditor
                      formProps={{
                        name: 'name',
                        // initialValue: open.data?.name || '',
                        // label: 'Create Table',
                      }}
                      height="500px"
                    />
                  </div>
                }
              />

              <Route
                path="/transaction/sales/create/:id/:referenceId/:code/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/sales/return/list/"
                element={<SalesReturnListLazy />}
              />
              <Route
                path="/sales/return/create/"
                element={<SalesReturnLazy />}
              />
              <Route
                path="/issue/karigar/create/"
                element={<IssueKarigarCreateLazy />}
              />
              <Route
                path="/issue/party/create/"
                element={<IssuePartyCreateLazy />}
              />
              <Route
                path="/issue/refine/create/"
                element={<IssueRefineCreateLazy />}
              />
              <Route
                path="/issue/karigar/edit/:issueid/"
                element={<IssueKarigarCreateLazy />}
              />
              <Route
                path="/issue/refine/edit/:issueid/"
                element={<IssueRefineCreateLazy />}
              />
              <Route
                path="/issue/party/edit/:issueid/"
                element={<IssuePartyCreateLazy />}
              />
              <Route
                path="/transaction/issue/edit/:id/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/issue-karigar/edit/:id/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/issue-refine/edit/:id/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/issue-party/edit/:id/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/issues/karigar/list/"
                element={<IssueKarigarListLazy />}
              />
              <Route
                path="/issues/party/list/"
                element={<IssuePartyListLazy />}
              />
              <Route
                path="/issues/refine/list/"
                element={<IssueRefineListLazy />}
              />
              <Route
                path="/receive/karigar/create/"
                element={<ReceiveKarigarLazy />}
              />
              <Route
                path="/receive/karigar/edit/:id"
                element={<ReceiveKarigarLazy />}
              />
              <Route
                path="/receives/karigar/list/"
                element={<ReceiveKarigarListLazy />}
              />
              <Route
                path="/receive/party/create/"
                element={<ReceivePartyLazy />}
              />
              <Route
                path="/receive/party/edit/:id"
                element={<ReceivePartyLazy />}
              />
              <Route
                path="/receives/party/list/"
                element={<ReceivePartyListLazy />}
              />
              <Route
                path="/receive/refine/create/"
                element={<ReceiveRefineLazy />}
              />
              <Route
                path="/receive/refine/edit/:id"
                element={<ReceiveRefineLazy />}
              />
              <Route
                path="/receives/refine/list/"
                element={<ReceiveRefineListLazy />}
              />
              <Route
                path="/sales/order/list/"
                element={<SalesOrderListLazy />}
              />
              <Route path="/sales/order/create/" element={<SalesOrderLazy />} />
              <Route
                path="/sales/order/pos/create/"
                element={<PosOrderLazy />}
              />
              <Route
                path="/sales/order/edit/:id"
                element={<SalesOrderLazy />}
              />
              <Route
                path="/transaction/sales/order/edit/:id"
                element={<SalesOrderCodeWindowLazy />}
              />
              <Route
                path="/transaction/sales/order/create/:id"
                element={<SalesOrderCodeWindowLazy />}
              />

              <Route
                path="/transaction/quotation/list/"
                element={<SalesQuotationList />}
              />
              <Route
                path="/sales/quotation/create/"
                element={<SalesQuotation />}
              />
              <Route
                path="/sales/quotation/edit/:id"
                element={<SalesQuotation />}
              />
              <Route
                path="/transaction/sales/quotation/edit/:id"
                element={<SalesQuotationWindow />}
              />
              <Route
                path="/transaction/sales/quotation/create/:id"
                element={<SalesQuotationWindow />}
              />
              <Route
                path="/purchase/return/code/window/:index"
                element={<PurchaseReturnCodeWindowLazy />}
              />
              <Route
                path="/sales/return/code/window/:index"
                element={<PurchaseReturnCodeWindowLazy />}
              />
              <Route
                path="/transaction/issue/refine/create/:id/:referenceId/:code/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/issue/karigar/create/:id/:referenceId/:code/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route
                path="/transaction/issue/party/create/:id/:referenceId/:code/"
                element={<UtilCodeWindowFormLazy />}
              />
              <Route path="/reports/" element={<ReportsLazy />} />
              <Route
                path="/purchase/reports/"
                element={<PurchaseReportLazy />}
              />
              <Route
                path="/purchase-details/reports/"
                element={<PurchaseDetailReportLazy />}
              />
              <Route path="/sales/reports/" element={<SalesReportLazy />} />
              <Route
                path="/sales-details/reports/"
                element={<SalesDetailsReportLazy />}
              />
              <Route
                path="/sales-register/reports/"
                element={<SalesRegisterReportLazy />}
              />
              <Route
                path="/sales-return/reports/"
                element={<SalesReturnReportLazy />}
              />
              <Route
                path="/sales-return-details/reports/"
                element={<SalesReturnDetailsReportLazy />}
              />
              <Route
                path="/purchase-return/reports/"
                element={<PurchaseReturnReportLazy />}
              />
              <Route
                path="/purchase-return-details/reports/"
                element={<PurchaseReturnDetailsReportLazy />}
              />
              <Route
                path="/sales-return-register/reports/"
                element={<SalesReturnRegisterReportLazy />}
              />
              <Route
                path="/sales-bill-summary/"
                element={<SalesBillSummaryLazy />}
              />
              <Route
                path="/sales/gross-profit/reports/"
                element={<SalesGrossProfitReportLazy />}
              />
              <Route
                path="/stock-valuation/reports/"
                element={<StockValuationReportLazy />}
              />
              <Route
                path="/stock-summary/reports/"
                element={<StockReportLazy />}
              />
              <Route
                path="/stock/detail/report/"
                element={<StockDetailReportLazy />}
              />
              <Route
                path="/opening/stock/detail/report/"
                element={<OpeningStockDetailsReportLazy />}
              />
              <Route
                path="/stock-receive/reports/"
                element={<StockReceiptReportLazy />}
              />
              <Route
                path="/stock/ledger/report/"
                element={<StockLedgerReportLazy />}
              />
              <Route
                path="/stock-receive-details/reports/"
                element={<StockReceiptDetailsReportLazy />}
              />
              <Route
                path="/issue-details/reports/"
                element={<IssueDetailsReportLazy />}
              />
              {/* <Route path="/karigar/report/" element={<KarigarReport />} /> */}
              <Route
                path="/karigar-issue-details/reports/"
                element={<KarigarIssueDetailsReportLazy />}
              />
              <Route
                path="/karigar-receive/reports/"
                element={<KarigarReceiveReportLazy />}
              />
              <Route
                path="/karigar-receive-details/reports/"
                element={<KarigarReceiveDetailsReportLazy />}
              />
              <Route
                path="karigar-balance/report/"
                element={<KarigarReportLazy />}
              />
              <Route path="/voucher/reports/" element={<VoucherReportLazy />} />
              <Route
                path="/voucher-details/reports/"
                element={<VoucherDetailsReportLazy />}
              />
              <Route
                path="/order-details/reports/"
                element={<OrderDetailreportLazy />}
              />
              <Route path="/order/reports/" element={<OrderReportLazy />} />
              <Route
                path="/order-status/reports/"
                element={<OrderStatusLazy />}
              />
              <Route
                path="/order/tracking/report/"
                element={<OrderTrackingReportLazy />}
              />
              <Route
                path="/day-book/reports/"
                element={<DayBookreportLazy />}
              />
              <Route
                path="/report/day-stock-ledger-report/"
                element={<DayStockLedgerReportLazy />}
              />
              <Route
                path="/report/stock-book-report/"
                element={<StockBookReportLazy />}
              />
              <Route
                path="/report/expense-report/"
                element={<ExpenseReportLazy />}
              />
              <Route
                path="/report/expense-report/details/:id/"
                element={<ExpenseDetailReportLazy />}
              />
              <Route path="/order/advance/report/" element={<AdvanceLazy />} />
              <Route
                path="sales/history/reports/"
                element={<SalesHistoryReportLazy />}
              />
              <Route
                path="sales-item/reports/"
                element={<SalesItemWiseReportLazy />}
              />
              <Route path="/ledger/reports/" element={<LedgerReportLazy />} />
              <Route
                path="/ledger/cash-bank/reports/"
                element={<CashBankReportLazy />}
              />
              <Route
                path="/ledger/karigar/reports/"
                element={<KarigarLedgerReportLazy />}
              />
              <Route
                path="/change/sales-rate/"
                element={<ChangeSalesRateLazy />}
              />
              <Route
                path="/change/tray-name/"
                element={<ChangeTrayNameLazy />}
              />
              <Route
                path="/change/sales-rate/history/report/"
                element={<SalesRateChangeHistoryLazy />}
              />
              <Route
                path="/change/tray-name/history/report/"
                element={<TrayNameChangeHistoryLazy />}
              />

              <Route
                path="/annex-5-report/"
                element={<IrdAnnex5ReportLazy />}
              />
              <Route
                path="/reports/ird/reports/pending-sync/"
                element={<PendingIrdReport />}
              />
              <Route
                path="/ird/reports/pending-credit-notes/sync/"
                element={
                  <PendingIrdReport
                    reportTitle="Upload Credit Notes on CBMS"
                    listUrl="/ird/reports/pending-credit-notes/sync/"
                    syncUrl="transactions/sales-return/sync-ird/"
                  />
                }
              />

              <Route
                path="/cash-bank-ledger-details/reports/:id"
                element={<LedgerDetailReportLazy />}
              />
              <Route
                path="/karigar/ledger-details/reports/:id"
                element={<LedgerDetailReportLazy />}
              />
              <Route
                path="/ledger-details/reports/:id"
                element={<LedgerDetailReportLazy />}
              />
              <Route
                path="/sundry-ledger-details/reports/:id"
                element={<LedgerDetailReportLazy />}
              />
              <Route
                path="/debtors-ledger-details/reports/:id"
                element={<LedgerDetailReportLazy />}
              />
              <Route
                path="/sundry-creditors/reports/"
                element={<SundryCreditorsReportLazy />}
              />
              <Route
                path="/sundry-debtors/reports/"
                element={<SundryDeptorsReportLazy />}
              />
              <Route
                path="/refine-issue-details/reports/"
                element={<RefineIssueDetailReportLazy />}
              />
              <Route
                path="/refine-receive/reports/"
                element={<RefineReceiveReportLazy />}
              />
              <Route
                path="/refine-profit-loss/report/"
                element={<RefineProfitLossReportLazy />}
              />
              <Route
                path="/refine-receive-details/reports/"
                element={<RefineReceiveDetailReportLazy />}
              />
              <Route
                path="/party-issue-details/reports/"
                element={<PartyIssueDetailReportLazy />}
              />
              <Route
                path="/party-receive/reports/"
                element={<PartyReceiveReportLazy />}
              />
              <Route
                path="/party-receive-details/reports/"
                element={<PartyReceiveDetailReportLazy />}
              />
              <Route
                path="/gold/history/reports/"
                element={<GoldRateHistoryLazy />}
              />
              <Route
                path="/loan/customer-ledger/report/"
                element={<CustomerLedgerReportLazy />}
              />
              <Route
                path="/loan/stock/report/"
                element={<LoanStockReportLazy />}
              />
              <Route
                path="/loan/stock-in-bank/report/"
                element={<LoanStockInBankReportLazy />}
              />
              <Route
                path="/loan/bank-wise-stock/report/"
                element={<LoanBankWiseStockReportLazy />}
              />
              <Route
                path="/loan/deal-tracking/report/"
                element={<LoanDealTrackingReportLazy />}
              />
              <Route
                path="/disable/report/edit/:id/"
                element={<DisableFirstTableLazy />}
              />
              <Route
                path="/disable/report/code/window/:id/"
                element={<DisableDynamicCodeWindowLazy />}
              />
              <Route
                path="/change/password/"
                element={<ChangePasswordLazy />}
              />
              <Route
                path="/payment/voucher/list/"
                element={<PaymentVoucherListLazy />}
              />
              <Route
                path="/payment/voucher/create/"
                element={<PaymentVoucherCreateLazy />}
              />
              <Route
                path="/payment/voucher/edit/:id"
                element={<PaymentVoucherEditLazy />}
              />
              <Route
                path="/receipt/voucher/list/"
                element={<ReceiptVoucherListLazy />}
              />
              <Route
                path="/receipt/voucher/create/"
                element={<ReceiptVoucherCreateLazy />}
              />
              <Route
                path="/receipt/voucher/edit/:id/"
                element={<ReceiptVoucherEditLazy />}
              />
              <Route
                path="/contra/voucher/list/"
                element={<ContraVoucherListLazy />}
              />
              <Route
                path="/contra/voucher/create/"
                element={<ContraVoucherCreateLazy />}
              />
              <Route
                path="/contra/voucher/edit/:id/"
                element={<ContraVoucherEditLazy />}
              />
              <Route
                path="/journal/voucher/list/"
                element={<JornalVoucherListLazy />}
              />
              <Route
                path="/journal/voucher/create/"
                element={<JornalVoucherCreateLazy />}
              />
              <Route
                path="/journal/voucher/edit/:id/"
                element={<JornalVoucherEditLazy />}
              />
              <Route
                path="/metal-to/cash/list/"
                element={<MetalToCashListLazy />}
              />
              <Route
                path="/metal-to/cash/create/"
                element={<MetalToCashLazy />}
              />
              <Route
                path="/transaction/metal-cash-payment/edit/:id/"
                element={<MetalToCashLazy />}
              />

              <Route path="/print-preview" element={<PrintPlayGround />} />
              <Route
                path="/accounting/cash-to-metals/list/"
                element={<CashToMetalListLazy />}
              />
              <Route
                path="/cash-to/metal/create/"
                element={<CashToMetalLazy />}
              />
              <Route
                path="/transaction/metal-cash-receipt/edit/:id/"
                element={<CashToMetalLazy />}
              />
              <Route
                path="/accounting/metal-transfer/list/"
                element={<MetalTransferListLazy />}
              />
              <Route
                path="/accounting/metal-transfer/create/"
                element={<MetalTransferCreateLazy />}
              />
              <Route
                path="/accounting/metal-transfer/:id/"
                element={<MetalTransferEditLazy />}
              />

              <Route path="/user/activity/" element={<UserActivityLazy />} />
              <Route path="/gold/rate/list/" element={<TodayGoldRateLazy />} />
              <Route
                path="/loan/party-loans/list/"
                element={<PartyLoanListLazy />}
              />
              <Route
                path="/loan/party-loans/create/"
                element={<PartyLoanDetailsLazy />}
              />
              <Route path="/loan/deals/list/" element={<DealListLazy />} />
              <Route
                path="/loan/deal/create/"
                element={<LoanDealCreateLazy />}
              />
              <Route
                path="/loan/deal/edit/:id"
                element={<LoanDealCreateLazy />}
              />
              <Route
                path="/loan/bank-issues/list/"
                element={<BankIssueListLazy />}
              />
              <Route
                path="/loan/bank-issue/create/"
                element={<BankIssueFormLazy />}
              />
              <Route
                path="/loan/bank-issue/edit/:id"
                element={<BankIssueFormLazy />}
              />
              <Route
                path="/loan/interest-receives/list/"
                element={<InterestReceivedListLazy />}
              />
              <Route
                path="/loan/interest-receives/create/"
                element={<InterestReceivedFormLazy />}
              />
              <Route
                path="/loan/interest-receives/edit/:id"
                element={<InterestReceivedFormLazy />}
              />
              <Route
                path="/loan/bank-receives/list/"
                element={<BankReceivesListLazy />}
              />
              <Route path="/check/excel/" element={<Check />} />
              <Route path="/loan/deals/close/list/" element={<DealClose />} />
              <Route
                path="/image-catalog"
                element={<ProductCatalogPageLazy />}
              />
              <Route
                path="/product/catalog/:id"
                element={<ProductDetailPageLazy />}
              />
              {/* <Route
                path="/test/contra/voucher/list"
                element={<ContraVoucherListTest />}
              />

              <Route
                path="/test/contra/voucher/create"
                element={<ContraVoucherCreate />}
              />

              <Route
                path="/test/contra/voucher/:id"
                element={<ContraVoucherEdit />}
              /> */}
              {/* <Route
                path="/test/receipt/voucher/list"
                element={<ReceiptVoucherListTest />}
              />

              <Route
                path="/test/receipt/voucher/create"
                element={<ReceiptVoucherCreate />}
              />

              <Route
                path="/test/receipt/voucher/:id"
                element={<ReceiptVoucherEdit />}
              /> */}
              {/* <Route
                path="/test/journal/voucher/list"
                element={<JournalVoucherListTest />}
              />

              <Route
                path="/test/journal/voucher/create"
                element={<JournalVoucherCreate />}
              />

              <Route
                path="/test/journal/voucher/:id"
                element={<JournalVocuherEdit />}
              /> */}
              <Route path="permission/denied" element={<UnAuthorizedLazy />} />
              <Route path="*" element={<ErrorLazy />} />
            </Route>
          </Route>

          {/* Admin Routes */}
          <Route
            element={
              <ProtectedRouteSetupAdmin
                allowedRole="admin"
                redirectTo="/admin/login/"
              />
            }
          >
            <Route
              path="/"
              element={
                <ToastProvider>
                  <AdminDashboardLayout />
                </ToastProvider>
              }
            >
              <Route path="admin/dashboard" element={<AdminDashboard />} />
              <Route path="user/list" element={<Customers />} />
              <Route path="user/create" element={<CreateCustomer />} />
              <Route path="user/:id/edit" element={<EditCustomer />} />

              <Route path="company/list" element={<AdminCompany />} />
              <Route path="company/create" element={<CreateCompany />} />
              <Route path="company/:id/edit" element={<EditCompany />} />
              <Route path="branch/list" element={<Branch />} />
              <Route path="bill-format/list/" element={<BillFormatAdmin />} />
              <Route
                path="/financial-year/list/"
                element={<FinancialYearLazy />}
              />
              <Route
                path="/bill-format/list/"
                element={<BillSetupListLazy />}
              />
              <Route
                path="/inventory/store/list/"
                element={<StoreSetupListLazy />}
              />
              <Route path="role/list" element={<Roles />} />
              <Route path="role/create" element={<CreateRole />} />
              <Route path="role/:id/edit" element={<CreateRole />} />
              <Route path="role/mapping/create/" element={<RoleMapping />} />
              <Route path="activate/users/" element={<UserAdmin />} />
              <Route
                path="device-identification/list/"
                element={<DeviceIdList />}
              />
              <Route
                path="user/company/mapping/list/"
                element={<UserCompanyMappingList />}
              />
              <Route
                path="/user/company/mapping/create/"
                element={<UserCompanyMappingCreate />}
              />
              <Route
                path="role/mapping/:id/edit/"
                element={<EditRoleMapping />}
              />
              <Route
                path="role/mapping/list/"
                More
                actions
                element={<RoleUserMappingList />}
              />
              <Route
                path="/role/menu/mapping/list/"
                element={<RoleMenuMappingList />}
              />
              <Route
                path="role/menu/mapping/create"
                element={<PermissionMenuMapping />}
              />
              <Route
                path="menu/mapping/:id1/:id2/:id3/edit/"
                element={<EditPermissionMenuMapping />}
              />
              <Route path="printer/create/" element={<CreatePrinter />} />
              <Route path="printer/edit/" element={<CreatePrinter />} />
              <Route path="printer/list/" element={<PrinterList />} />
              <Route
                path="/transaction/bill-setup/list/"
                element={<JweleryNewStickerLazy />}
              />

              {/* <Route
                path="transaction/qz-tray-setup/list/"
                element={'this is a test component'}
              /> */}

              <Route
                path="transaction/qz-tray-setup/list/"
                element={<QzTraySetupList />}
              />
              <Route
                path="transaction/qz-tray-setup/create"
                element={<CreateQzTraySetup />}
              />
              <Route
                path="transaction/qz-tray-setup/:id/edit"
                element={<EditQzTraySetup />}
              />

              <Route
                path="/transaction/bill-set-up/new/"
                element={<JAddTemplateLazy mode="New" />}
              />
              <Route
                path="/transaction/bill-set-up/edit/"
                element={<BillSetupDesignerLazy mode="Edit" />}
              />
              <Route
                path="/transaction/bill-set-up/classic/edit/"
                element={<ClassicTemplateEditLazy />}
              />
              <Route path="printer/barcode" element={<PRNsettings />} />
              <Route path="printer/barcode/prn" element={<AddPRN />} />
              <Route
                path="printer/barcode/layout"
                element={
                  <TransactionContextProvider>
                    <LayoutSettings />
                  </TransactionContextProvider>
                }
              />
              {/* <Route path="menu/mapping/:id1/:id2/edit/" element={<EditTest />} /> */}
              <Route path="permission/denied" element={<UnAuthorizedLazy />} />
              <Route path="*" element={<ErrorLazy />} />
            </Route>
          </Route>

          {/* SuperAdmin Routes */}
          <Route
            element={
              <ProtectedRouteSetupAdmin
                allowedRole="superadmin"
                redirectTo="/superadmin/login/"
              />
            }
          >
            <Route
              path="/"
              element={
                <ToastProvider>
                  <AdminDashboardLayout />
                </ToastProvider>
              }
            >
              <Route
                path="/superadmin/dashboard"
                element={<SuperAdminDashboard />}
              />
              <Route path="/subscription/list" element={<Subscription />} />
              <Route
                path="/subscription/create"
                element={<CreateSubscriptionForm />}
              />
              <Route
                path="/subscription/:id/edit"
                element={<EditSubscriptionForm />}
              />

              <Route path="/version/list" element={<VersionList />} />

              <Route
                path="/control-settings/list"
                element={<ControlSettingsList />}
              />

              <Route path="/version/create" element={<CreateVerison />} />
              <Route
                path="/version/:id/edit"
                element={<EditSubscriptionForm />}
              />
              <Route
                path="/superadmin/version/menu/mapping/list/"
                element={<SuperadminVersionMenuMappingList />}
              />
              <Route
                path="/superadmin/version/menu/mapping/create/"
                element={<SuperadminVersionMenuMapping />}
              />
              <Route
                path="/superadmin/version/menu/mapping/:id/edit/"
                element={<EditSuperadminVersionMenuMapping />}
              />
              <Route
                path="/superadmin/company/limits/list"
                element={<CompanyLimitList />}
              />
              <Route
                path="/superadmin/branch/version/assignment/list/"
                element={<BranchVersionAssignmentList />}
              />
              <Route path="/admin/user/list" element={<SuperAdminUserList />} />
              <Route
                path="/admin/user/create"
                element={<SuperAdminUserCreate />}
              />
              <Route
                path="/admin/user/:id/edit"
                element={<SuperAdminUserEdit />}
              />
              <Route
                path="admin/activate/users"
                element={<SuperAdminUserActive />}
              />
              <Route path="/permission/denied" element={<UnAuthorizedLazy />} />
              <Route path="*" element={<ErrorLazy />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
};

export default RouteSetup;
